export default "__VITE_ASSET__BSynmF7T__"